import { render } from "./lostLicense.vue?vue&type=template&id=4fc5cc55"
import script from "./lostLicense.vue?vue&type=script&lang=js"
export * from "./lostLicense.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__